import { FileUploader } from "@/common/components/FileUploader";
import { ChevronsRight, User2Icon } from "lucide-react";
import { useParams } from "react-router-dom";
import useAnpReport from "../../hooks/useAnpHistoricalReport";
import { getFilenameFromUrl } from "@/common/utils/getFilenameFromUrl";
import { formatDateRange, formatDateTime } from "@/common/utils/formatters";
import AnpPricesTable from "../../components/AnpHistoricalPricesTable";
import { ImageWithPlaceholder } from "@/common/components/ImageWithPlaceholder";
import { ErrorMessageWrapper } from "@/common/components/ErrorMessageWrapper";
import GoBackButton from "@/common/components/GoBackButton";

const AnpHistoricalReportsShow = () => {
  const { id } = useParams();

  const {
    data: anpReport,
    error: anpReportError = {} as any,
    refetch: refetchAnpReport,
  } = useAnpReport({ id });

  return (
    <div className="flex flex-col gap-6">
      <div className="flex justify-between items-center">
        <div className="flex gap-4 items-center">
          <GoBackButton fallback="/anp-historical-reports" searchLastRouteFromFallback />

          <div className="flex gap-2 items-center">
            <p className="text-white-400 font-normal">
              Tabelas Série Historica Mensal ANP
            </p>

            {anpReport && (
              <>
                <ChevronsRight className="text-white-400" />

                <h2>
                  {anpReport?.document ? getFilenameFromUrl(anpReport.document?.url) : ''}
                </h2>
              </>
            )}

          </div>
        </div>
      </div>

      <ErrorMessageWrapper
        className="max-h-[calc(100vh-128px)]"
        statusCode={anpReportError?.status}
        refetchFunction={refetchAnpReport}
      >
        <div className="flex justify-between">
          <div className="flex flex-col gap-4">
            <div className="flex flex-col gap-1">
              <p className="italic font-light text-xs">Nome da tabela</p>
              <p className="font-bold text-md">
                {anpReport?.document ? getFilenameFromUrl(anpReport.document?.url) : ""}
              </p>
            </div>

            <div className="flex gap-8">
              <div className="flex flex-col gap-1">
                <p className="italic font-light text-xs">Período de competência</p>
                <p className="font-bold text-md">
                  {anpReport?.initial_date &&
                    anpReport?.end_date &&
                    formatDateRange(new Date(`${anpReport?.initial_date} `), new Date(`${anpReport?.end_date} `))}
                </p>
              </div>

              {anpReport?.approved_by && (
                <>
                  <div className="flex flex-col gap-1">
                    <p className="italic font-light text-xs">Aprovado por</p>

                    <div className="flex items-center gap-2">
                      <ImageWithPlaceholder
                        placeholderIcon={User2Icon}
                        url={anpReport.approved_by.profile_picture?.url}
                        className="w-6 h-6"
                        iconClassName="w-4 h-4"
                      />

                      <p className="font-bold text-md">{anpReport?.approved_by?.full_name}</p>
                    </div>
                  </div>

                  <div className="flex flex-col gap-1">
                    <p className="italic font-light text-xs">Aprovado às</p>
                    <p className="font-bold text-md">
                      {anpReport.approved_at && formatDateTime(new Date(anpReport.approved_at))}
                    </p>
                  </div>
                </>
              )}
            </div>
          </div>

          {anpReport?.document && (
            <div>
              <FileUploader
                className="w-48"
                disabled
                fileName={getFilenameFromUrl(anpReport.document?.url)}
                currentFileUrl={anpReport.document?.url}
              />
            </div>
          )}
        </div>

      <AnpPricesTable reportId={id} geoType="Geo::City" />

      </ErrorMessageWrapper>
    </div>
  );
};

export default AnpHistoricalReportsShow;
